import ApiService from './ApiService'
import appConfig from '../configs/app.config'
 
/*
    sadece dil json'ı getirir
*/
export async function getLanguage (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/language.php',
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        data
    })
}

/*
    // Yeni bir dil ekler
    "code": "string",
    "name": "string",
    "description": "string"
*/
export async function setLanguage (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/language.php',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
    // o koda ait dili getirir
    "code": "string",
*/
export async function getLanguageByCode (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/language.php?code='+data.code,
        method: 'get',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
    // Mevcut dili günceller
    "id": integer,
    "code": "string",
    "name": "string",
    "description": "string"
*/
export async function updateLanguage (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/language.php?id='+data.id,
        method: 'put',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
    // Mevcut dili siler
    "id": integer,
*/
export async function deleteLanguage (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/language.php?=id'+data.id,
        method: 'delete',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
    O dile ait translationları getirir
    "languageCode": string,
*/
export async function getTranslation (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/translations.php?code='+data.code,
        method: 'get',
        headers: {'Content-Type': 'application/json'},
        data
    })
}

/*
    // Yeni bir translation ekler veya id değeri gönderilirse günceller
    "id": 0, // eğer bu boş ise yeni ekler, varsa varolanı günceller
    "key": "string",
    "value": "string",
    "languageCode": "string"
*/
export async function saveTranslation (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/translations.php',
        method: 'post',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}

/*
    // Mevcut translation'ı siler
    "id": integer,
*/
export async function deleteTranslation (data) {
    return ApiService.fetchData({
        url: appConfig.APIURL + 'general/translations.php?id='+data.id,
        method: 'delete',
        headers: {'Content-Type' : 'application/json'},
        data
    })
}